/**
 * Bearer-token guard for /c/:positionToken/info (+ Plan 03-06 /q/:n, /done).
 * Candidate analog of RequireRole — adapts the Wave A T-1 redirect pattern for the
 * sessionStorage Bearer token model (5.0h). Missing token → toast + Navigate to the
 * consent screen (NOT /login — candidates never see the admin login).
 */
import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { getCandidateSessionToken } from "@/features/candidate/api";

export default function RequireCandidateSession() {
  const { positionToken } = useParams<{ positionToken: string }>();
  const { t } = useTranslation("candidate");
  const sessionToken = getCandidateSessionToken();

  useEffect(() => {
    if (!sessionToken) {
      toast.error(t("errors.session_expired"));
    }
  }, [sessionToken, t]);

  if (!sessionToken) {
    return <Navigate to={`/c/${positionToken}`} replace />;
  }
  return <Outlet />;
}
